import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  deleteStockReconcillation,
  getStockReconcillation,
} from '../../network/stockReconcillation';
import { deleteStockEntry, getStockEntry } from '../../network/stockEntry';
import { deleteEmployee, getEmployee } from '../../network/employee';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
const Employee = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteEmployee(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getEmployee] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.Employees,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/employee/edit/${record?.name}`);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeleteEmployee + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.Employees}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.employeeName,
      dataIndex: 'employee_name',
      key: 'employee_name',
    },
    {
      title: t.dateOfJoining,
      dataIndex: 'date_of_joining',
      key: 'date_of_joining',
    },
    {
      title: t.department,
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: t.designation,
      dataIndex: 'designation',
      key: 'designation',
    },
    {
      title: t.status,
      dataIndex: 'status',
      key: 'status',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/employee/edit/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.DeleteEmployee + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.HR } subTitle={t.Employees} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/employee/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddEmployee}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default Employee;
